export default {"src":"/_next/static/media/zoom-in.8a278670.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};